import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { BrandLogo } from "../components/BrandLogo";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { ROLES } from "../lib/format";
import { Field } from "../components/Field";
import { Button } from "../components/ui/button";

export default function Invitacion() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);
  const [f, setF] = useState({ nombre: "", password: "", password2: "" });
  const [ok, setOk] = useState(false);

  useEffect(() => {
    api.get(`/public/invitations/${token}`).then((r) => {
      setInfo(r.data);
      setF((p) => ({ ...p, nombre: r.data.nombre || "" }));
    }).catch((e) => setError(errMsg(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (f.password !== f.password2) return toast.error("Las contraseñas no coinciden");
    try {
      await api.post(`/public/invitations/${token}/accept`, { nombre: f.nombre, password: f.password });
      setOk(true);
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-blue-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 space-y-6 text-slate-900">
        <div className="flex items-center"><BrandLogo className="h-8" /></div>
        {error && <p className="text-rose-700 text-sm" data-testid="invitation-error">{error}</p>}
        {ok && (
          <div className="space-y-4 text-center" data-testid="invitation-success">
            <CheckCircle2 className="mx-auto text-emerald-600" size={40} />
            <p>Cuenta creada para <b>{info.correo}</b>.</p>
            <Link to="/ingresar"><Button className="bg-slate-900 hover:bg-slate-800" data-testid="invitation-go-login">Ingresar</Button></Link>
          </div>
        )}
        {info && !ok && (
          <form onSubmit={submit} className="space-y-4" data-testid="invitation-form">
            <h1 className="font-heading text-2xl font-bold tracking-tight">Únete a {info.empresa}</h1>
            <p className="text-sm text-slate-600">Fuiste invitado como <b>{ROLES[info.rol]}</b> con el correo <b>{info.correo}</b>.</p>
            <Field id="inv-nombre" label="Nombre completo" required value={f.nombre} onChange={(e) => setF({ ...f, nombre: e.target.value })} />
            <Field id="inv-password" label="Contraseña" type="password" minLength={12} hint="Mínimo 12 caracteres" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} />
            <Field id="inv-password2" label="Repetir contraseña" type="password" required value={f.password2} onChange={(e) => setF({ ...f, password2: e.target.value })} />
            <Button type="submit" className="w-full bg-slate-900 hover:bg-slate-800" data-testid="invitation-submit-button">Crear mi cuenta</Button>
          </form>
        )}
      </div>
    </div>
  );
}
